









































    import { Vue, Component, Mixins } from 'vue-property-decorator';

	import TextHeader from '@/components/Common/TextHeader.vue';
    import {Controller} from "@/plugins/Controller";
    import BaseComponent from "@/plugins/BaseComponent";

    import { Hooper, Slide } from 'hooper';
    import 'hooper/dist/hooper.css';

	@Component({
		components:{
		    TextHeader,
            Hooper,
			Slide,
		}
	})
	export default class News extends Mixins(BaseComponent) {
        private items: any[] = [];
        private controller: Controller = new Controller();

        mounted(){
            this.showLoader();
            this.controller.GetNews()
                .then(this.gotData)
                .catch(this.hideLoader)
        }

        gotData(response:any){
            this.hideLoader()
            this.items = response?.data;
        }

        slideNext(){
			(this.$refs.hooper as any).slideNext()
		}

		slidePrev(){
            (this.$refs.hooper as any).slidePrev()
		}
	}
